import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { trackingPageOrderSchema } from "./tracking-page-order";

export const getTrackingPageOrder = {
  name: "getTrackingPageOrder" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({ trackingPageOrder: trackingPageOrderSchema.nullable() }),
};
